import React from 'react'

export function Icon ({ icon }) {
    return <i className="material-icons">{ icon }</i>
}


// WEBPACK FOOTER //
// ./src/components/Icon/index.js